import { Panel, PanelBorderRadius, PanelBorderStyle, PanelTheme } from '@apply/components';

export const UnsupportedPaymentMessage = () => {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', textAlign: 'center', paddingTop: '2rem' }}>
            <Panel
                theme={PanelTheme.Red}
                borderRadius={PanelBorderRadius.Small}
                borderStyle={PanelBorderStyle.None}
                width={'100%'}
            >
                We apologize, we currently only support Visa and Mastercard.
            </Panel>
        </div>
    );
};
